module.exports = __webpack_public_path__ + "img/sda.23c1c9ee.svg";